<div id="status-bar" class="d-flex flex-row justify-content-between align-items-center col-12 ps-2 pe-2 bg--white-750">
    <p class="font-light text-single-line font-size-08rm color--white-500 p-0 m-0">
        <span>{{VoltaCommon.VOLTA_NAME}} is designed and developed by {{VoltaCommon.VOLTA_DEVELOPER}}</span>
        <span class="font-thin"> • </span>
        <span>Version {{VoltaCommon.VOLTA_VERSION}}</span>
    </p>

    <app-processes-status/>

</div>